import { render, staticRenderFns } from "./PageHomepageBetweenSliderAndUniqueSellingPointsHook.vue?vue&type=template&id=833f23b0&"
import script from "./PageHomepageBetweenSliderAndUniqueSellingPointsHook.js?vue&type=script&lang=js&"
export * from "./PageHomepageBetweenSliderAndUniqueSellingPointsHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports